/*
 * @Author: chenmengnan
 * @Date: 2024-06-12 17:16:02
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-01-22 10:07:48
 * @Description: 审核管理接口
 * @FilePath: \web\src\api\dataManagement\examineManagement.js
 */
import axios from '@/utils/request';
import config from '@/config/config';
const {
  serveIp: { mine_ip },
} = config;

/** 分页查询接口 */
export const getLsitPageApi = (body, option) => axios.post(`/sys/register/page`, body, option);

/* 审核 */
export const checkApi = (params) => {
  return config.isRequestError(axios.post(`/sys/register/check`, params));
};

/* 导出 */
export const userCheckDownApi = (body, option) => {
  return axios.post(
    `/sys/register/export`,
    body,
    Object.assign(
      {
        responseType: 'blob',
      },
      option,
    ),
  );
};
